<template>
  <div class="l-c">
    <div class="login-image-container">
      <img src="@/assets/image/login_page_image.jpeg" alt="Login Image" class="login-image">
    </div>
    <el-form ref="ruleForm2" :model="ruleForm2" :rules="rules2" label-position="right" label-width="0"
      class="demo-ruleForm login-container" status-icon>
      <div class="login-form">
        <img src="@/assets/image/eclub-logo-1-theme.png" alt="eClub Logo" class="logo">
        <h2 style="text-align: center; margin-bottom: 20px; color: #FF6B4A;">Your One-stop School Club System</h2>
        <el-form-item prop="login_type" style="width: 100%">
          <el-select v-model="ruleForm2.login_type" style="width: 100%" placeholder="Please select login type" @change="loginTypeSel">
            <el-option value="Student" label="Student"></el-option>
            <el-option value="Advisor" label="Advisor"></el-option>
            <el-option value="SchoolAdmin" label="School Admin"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="loginType==='Student' || loginType==='Advisor'" prop="student_email" style="width: 100%">
          <el-input v-model="ruleForm2.student_email" type="text" auto-complete="off"
                    placeholder="Please login with your email" />
        </el-form-item>
        <el-form-item v-if="loginType==='SchoolAdmin'" prop="employee_email" style="width: 100%">
          <el-input v-model="ruleForm2.admin_email" type="text" auto-complete="off"
            placeholder="Please login with your email" />
        </el-form-item>

        <!-- Login method selection (OTP vs Password) for Student and Advisor -->
        <el-form-item v-if="loginType==='Student' || loginType==='Advisor'" style="width: 100%">
          <el-radio-group v-model="loginMethod" @change="onLoginMethodChange">
            <el-radio label="otp">Login with OTP Code</el-radio>
            <el-radio label="password">Login with Password</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- OTP input for Student and Advisor when OTP method is selected -->
        <el-form-item v-if="(loginType==='Student' || loginType==='Advisor') && loginMethod==='otp'" prop="verify_code" style="width: 100%">
          <el-input v-model="ruleForm2.verify_code" auto-complete="off" placeholder="Please enter the code"
            type="text" >
            <el-button slot="suffix" class="send_code" @click="sendCode" :disabled="countdown > 0">
              {{ countdown > 0 ? `Resend (${countdown}s)` : 'Send Code' }}
            </el-button>
          </el-input>
        </el-form-item>

        <!-- Password input for Student and Advisor when password method is selected -->
        <el-form-item v-if="(loginType==='Student' || loginType==='Advisor') && loginMethod==='password'" prop="password" style="width: 100%">
          <el-input v-model="ruleForm2.password" auto-complete="off" placeholder="Please enter your password"
            type="password" />
        </el-form-item>

        <!-- Password input for School Admin (always shows password) -->
        <el-form-item v-if="loginType==='SchoolAdmin'" prop="employee_pwd" style="width: 100%">
          <el-input v-model="ruleForm2.admin_pwd" auto-complete="off" placeholder="Please enter your password"
            type="password" />
        </el-form-item>

        <!-- Help links section -->
        <div class="help-links" v-if="loginType==='Student' || loginType==='Advisor'">
          <span v-if="loginMethod==='otp'" class="help-link" @click="showOtpHelp">
            Can't receive our OTP emails?
          </span>
          <span v-if="loginMethod==='password'" class="help-link" @click="showForgotPassword">
            Forgot your password?
          </span>
        </div>

        <span v-if="!!error_text" style="color: red" class="error_text">{{
          error_text
          }}</span>
        <el-form-item style="width: 100%">
          <el-button :loading="logining" type="primary" style="width: 100%" @click="submit">Login</el-button>
        </el-form-item>

        <div class="official-site-link" style="text-align: center; margin-top: 20px;">
          <router-link to="/official/home" class="official-link">
            Learn More About eClub
          </router-link>
        </div>
      </div>
    </el-form>

    <!-- OTP Help Dialog -->
    <el-dialog
      title="Can't receive OTP emails?"
      :visible.sync="otpHelpDialogVisible"
      width="500px"
      :close-on-click-modal="true">
      <div class="help-dialog-content">
        <p><strong>Here are some tips to help you receive OTP emails:</strong></p>
        <ol>
          <li><strong>Check your spam/junk folder:</strong> OTP emails might be categorized as spam by your email system. Please check your spam folder or trash folder.</li>
          <li><strong>Email security blocking:</strong> If your email security system blocks our emails, you can consider using another email address for login.</li>
          <li><strong>Use password instead:</strong> If you have set up a password before, you can switch to "Login with Password" option above.</li>
          <li><strong>Need a password?</strong> If you have never set up a password and cannot receive OTP emails, please send an email to <a href="mailto:contact@eae.international">contact@eae.international</a> from your registered email address, requesting password setup assistance. We will send you a password setting link after verifying your possession of the email address for your account.</li>
        </ol>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="otpHelpDialogVisible = false">Got it</el-button>
      </span>
    </el-dialog>

    <!-- Forgot Password Dialog -->
    <el-dialog
      title="Reset Your Password"
      :visible.sync="forgotPasswordDialogVisible"
      width="500px"
      :close-on-click-modal="false">
      <div class="forgot-password-content">
        <p>We will send a password reset link to your email address. Please fill in the following information to verify your identity:</p>
        <el-form ref="resetForm" :model="resetForm" label-position="top">
          <el-form-item label="Email" required>
            <el-input v-model="resetForm.email" placeholder="Your registered email"></el-input>
          </el-form-item>
          <el-form-item label="Last Name (Family Name) in English" required>
            <el-input v-model="resetForm.lastName" placeholder="Your last name in English"></el-input>
          </el-form-item>
          <el-form-item label="Given Name (First Name) in English" required>
            <el-input v-model="resetForm.givenName" placeholder="Your given name in English"></el-input>
          </el-form-item>
          <el-form-item label="Account Type" required>
            <el-select v-model="resetForm.userType" style="width: 100%">
              <el-option value="student" label="Student"></el-option>
              <el-option value="advisor" label="Advisor"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="forgotPasswordDialogVisible = false">Cancel</el-button>
        <el-button type="primary" :loading="sendingResetLink" @click="sendResetLink">Send Reset Link</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { loginByAdvisor, loginByAccountAdmin, createLoginOPT, loginByStudent, getAccountContactsAndClubs, loginByStudentWithPassword, loginByAdvisorWithPassword, sendPasswordResettingLink } from "../../api/eclub";
import {
  setUserId,
  setUserName,
  setUserAccountCountry,
  setUserType,
  setAccountId,
  setUserEmail,
  setSchoolName,
  setAccountName,
} from "../../utils/store";
//2个账号：yinzehu@sina.cn， 密码  ： impact 可以当老师和学生，还有一个是你的账号，当学生：chen.zhibo@hotmail.com 密码 = myideamatters
export default {
  name: "Login",
  data() {
    return {
      error_text: "",
      logining: false,
      countdown: 0,
      countdownTimer: null,
      loginMethod: 'otp', // 'otp' or 'password'
      ruleForm2: {
        admin_email: "",
        admin_pwd: "",
        login_type: "Student",
        student_email: "",
        verify_code: "",
        password: "",
      },
      loginType: 'Student',
      rules2: {
        reviewer_email: [
          {
            required: true,
            message: "Please enter your email",
            trigger: "blur",
          },
        ],
        reviewer_pwd: [
          {
            required: true,
            message: "Please enter your password",
            trigger: "blur",
          },
        ],
        login_type: [
          {
            required: true,
            message: "Please select login type",
            trigger: "blur",
          },
        ],
      },
      // OTP Help Dialog
      otpHelpDialogVisible: false,
      // Forgot Password Dialog
      forgotPasswordDialogVisible: false,
      sendingResetLink: false,
      resetForm: {
        email: '',
        lastName: '',
        givenName: '',
        userType: 'student'
      },
    };
  },
  mounted(){
    console.log('测试自动部署')
  },
  beforeDestroy() {
    // Clear countdown timer if component is destroyed
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer)
    }
  },
  methods: {
    loginTypeSel(val){
      console.log(val,'loginType')
      this.loginType = val
      // Reset login method to OTP for Student/Advisor
      if(val === 'Student' || val === 'Advisor') {
        this.loginMethod = 'otp'
      }
      // Update reset form user type
      if(val === 'Student') {
        this.resetForm.userType = 'student'
      } else if(val === 'Advisor') {
        this.resetForm.userType = 'advisor'
      }
    },
    onLoginMethodChange(val) {
      // Clear error text when switching login method
      this.error_text = ''
    },
    showOtpHelp() {
      this.otpHelpDialogVisible = true
    },
    showForgotPassword() {
      // Pre-fill email if already entered
      this.resetForm.email = this.ruleForm2.student_email
      this.forgotPasswordDialogVisible = true
    },
    sendResetLink() {
      // Validate reset form
      if(!this.resetForm.email) {
        this.$message.error('Please enter your email')
        return
      }
      if(!this.resetForm.lastName) {
        this.$message.error('Please enter your last name')
        return
      }
      if(!this.resetForm.givenName) {
        this.$message.error('Please enter your given name')
        return
      }

      this.sendingResetLink = true
      sendPasswordResettingLink(
        this.resetForm.email,
        this.resetForm.userType,
        this.resetForm.lastName,
        this.resetForm.givenName
      ).then(res => {
        this.sendingResetLink = false
        let result = res.data
        if(result.code === 0) {
          this.$message.success('Password reset link sent! Please check your email.')
          this.forgotPasswordDialogVisible = false
          // Clear form
          this.resetForm = {
            email: '',
            lastName: '',
            givenName: '',
            userType: this.resetForm.userType
          }
        } else {
          this.$message.error(result.msg || 'Failed to send reset link')
        }
      }).catch(err => {
        this.sendingResetLink = false
        this.$message.error('Network error. Please try again.')
      })
    },
    sendCode(){
      if (this.ruleForm2.student_email == "") {
        this.$message.error("Please enter your email");
        return;
      }
      if (this.countdown > 0) {
        return; // Prevent sending if countdown is active
      }
      createLoginOPT(this.ruleForm2.student_email).then((res) => {
        console.log(res.data,'createLoginOPT')
        let result = res.data
        if(result.code === 0){
          this.$message.success('Sent Successfully');
          // Start countdown
          this.countdown = 60;
          this.countdownTimer = setInterval(() => {
            this.countdown--;
            if (this.countdown <= 0) {
              clearInterval(this.countdownTimer);
              this.countdownTimer = null;
            }
          }, 1000);
        }else{
          this.$message.error(result.msg || 'Verification code sent failed. Please try again.')
        }
      })
    },
    submit() {
      console.log('切换服务器222')
      this.logining = false;
      this.error_text = "";

      // Validate based on login type and method
      if(this.loginType === "Student" || this.loginType === "Advisor"){
        if (this.ruleForm2.student_email == "") {
          this.$message.error("Please enter your email");
          return;
        }
        if (this.loginMethod === 'otp' && this.ruleForm2.verify_code == "") {
          this.$message.error("Please enter the code");
          return;
        }
        if (this.loginMethod === 'password' && this.ruleForm2.password == "") {
          this.$message.error("Please enter your password");
          return;
        }
      }else{
        if (this.ruleForm2.admin_email == "") {
          this.$message.error("Please enter your email");
          return;
        }
        if (this.ruleForm2.admin_pwd == "") {
          this.$message.error("Please enter your password");
          return;
        }
      }

      // Hardcoded admin credentials (for testing)
      if (
        this.ruleForm2.admin_email === "admin" &&
        this.ruleForm2.admin_pwd === "yiquanTodo"
      ) {
        setUserId("admin");
        setUserName("admin");
        setUserType("admin");
        setUserAccountCountry("China");
        setSchoolName("Admin Portal");
        this.$UserData.user_name = "admin";
        this.$UserData.account_country = "China";
        this.$root.$emit('user-logged-in', true);
        this.$router.push("/home/adminform");
        return;
      }

      this.logining = true;

      if (this.ruleForm2.login_type == 'SchoolAdmin') {
        loginByAccountAdmin(this.ruleForm2.admin_email, this.ruleForm2.admin_pwd).then((res) => {
          this.logining = false;
          let result = res.data
          if (result.code == 0) {
            setUserId(result.data._id.$id);
            setUserEmail(this.ruleForm2.admin_email);
            let account_country = "China";
            if (result.data.account_country) {
              account_country = result.data.account_country;
            }
            setUserAccountCountry(account_country);
            let user_name = result.data.account_nameEN;
            if (!user_name || user_name == '') {
              user_name = result.data.account_name;
            }
            setUserName(user_name);
            setUserType("schoolAdmin");
            setAccountId(result.data._id.$id);
            // Set school name (for school admin, the school name is the account name)
            let school_name = result.data.account_nameEN || result.data.account_name;
            setSchoolName(school_name);
            this.$UserData.user_name = user_name;
            this.$UserData.account_country = account_country;
            this.$root.$emit('updateUserName', user_name);
            this.$root.$emit('user-logged-in', true);
            this.$router.push("/home/schoolclubs");
          } else {
            this.error_text = result.msg;
          }
        }).catch(() => {
          this.logining = false;
          this.error_text = "Network error. Please try again.";
        })
      } else if (this.ruleForm2.login_type === "Advisor") {
        if(this.loginMethod === 'otp') {
          // OTP login
          loginByAdvisor({
            contact_email: this.ruleForm2.student_email,
            verify_code: this.ruleForm2.verify_code,
          }).then((res1) => {
            this.logining = false;
            let result1 = res1.data;
            console.log('Advisor login response:', result1.data);
            if (result1.code == 0) {
              this.handleAdvisorLoginSuccess(result1.data);
            } else {
              this.error_text = result1.msg;
            }
          }).catch(() => {
            this.logining = false;
            this.error_text = "Network error. Please try again.";
          });
        } else {
          // Password login
          loginByAdvisorWithPassword(this.ruleForm2.student_email, this.ruleForm2.password).then((res1) => {
            this.logining = false;
            let result1 = res1.data;
            console.log('Advisor password login response:', result1.data);
            if (result1.code == 0) {
              this.handleAdvisorLoginSuccess(result1.data);
            } else {
              this.error_text = result1.msg;
            }
          }).catch(() => {
            this.logining = false;
            this.error_text = "Network error. Please try again.";
          });
        }
      } else {
        // Student login
        if(this.loginMethod === 'otp') {
          // OTP login
          loginByStudent(
            this.ruleForm2.student_email,
            this.ruleForm2.verify_code
          ).then((res) => {
            this.logining = false;
            let result = res.data;
            console.log('Student login response:', result.data);
            if (result.code == 0) {
              this.handleStudentLoginSuccess(result.data);
            } else {
              this.error_text = result.msg || 'Incorrect verification code';
            }
          }).catch(() => {
            this.logining = false;
            this.error_text = "Network error. Please try again.";
          });
        } else {
          // Password login
          loginByStudentWithPassword(
            this.ruleForm2.student_email,
            this.ruleForm2.password
          ).then((res) => {
            this.logining = false;
            let result = res.data;
            console.log('Student password login response:', result.data);
            if (result.code == 0) {
              this.handleStudentLoginSuccess(result.data);
            } else {
              this.error_text = result.msg;
            }
          }).catch(() => {
            this.logining = false;
            this.error_text = "Network error. Please try again.";
          });
        }
      }
    },
    handleStudentLoginSuccess(data) {
      setUserId(data._id.$id);
      setUserEmail(this.ruleForm2.student_email);
      let account_country = "China";
      if (data.account_country) {
        account_country = data.account_country;
      }
      setUserAccountCountry(account_country);
      const user_name =
        data.student_givenName_pinyin + ' ' + data.student_lastName_pinyin;
      setUserName(user_name);
      setUserType("student");
      setAccountId(data.account_id);
      this.$UserData.user_name = user_name;
      this.$UserData.account_country = account_country;
      this.$root.$emit('updateUserName', user_name);

      // Check if account_name is already in the response
      if (data.account_name) {
        setSchoolName(data.account_name);
        console.log('School name set for student from login response:', data.account_name);
        this.$root.$emit('user-logged-in', true);
        this.$router.push("/home/studentclubs");
      } else {
        // Fetch account info to get school name
        getAccountContactsAndClubs(data.account_id).then((accountRes) => {
          console.log('Student account response:', accountRes.data);
          if (accountRes.data && accountRes.data.data) {
            // Check different possible paths for account name
            let school_name = null;
            if (accountRes.data.data.account) {
              school_name = accountRes.data.data.account.account_nameEN ||
                           accountRes.data.data.account.account_name;
            } else if (accountRes.data.data.account_nameEN) {
              school_name = accountRes.data.data.account_nameEN;
            } else if (accountRes.data.data.account_name) {
              school_name = accountRes.data.data.account_name;
            }

            if (school_name) {
              setSchoolName(school_name);
              console.log('School name set for student:', school_name);
            }
          }
          this.$root.$emit('user-logged-in', true);
          this.$router.push("/home/studentclubs");
        }).catch((error) => {
          console.error('Failed to fetch account info for student:', error);
          // If fetching account info fails, proceed without school name
          this.$root.$emit('user-logged-in', true);
          this.$router.push("/home/studentclubs");
        });
      }
    },
    handleAdvisorLoginSuccess(data) {
      setUserId(data._id.$id);
      setUserEmail(this.ruleForm2.student_email);
      let account_country = "China";
      if (data.account_country) {
        account_country = data.account_country;
      }
      setUserAccountCountry(account_country);
      const user_name =
        data.contact_givenName + ' ' + data.contact_lastName;
      setUserName(user_name);
      setUserType("advisor");
      setAccountId(data.account_id);

      // Get account name from login response
      const account_name = data.account_nameEN || data.account_name;
      if (account_name) {
        setSchoolName(account_name);
        setAccountName(account_name);
        console.log('Account name set for advisor:', account_name);
      }

      this.$UserData.user_name = user_name;
      this.$UserData.account_country = account_country;
      this.$root.$emit('updateUserName', user_name);
      this.$root.$emit('user-logged-in', true);
      this.$router.push("/home/adviserclubs");
    }
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.l-c {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  background: #fff;

  .login-image-container {
    width: 60%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    overflow: hidden;

    .login-image {
      width: 100%;
      height: auto;
      object-fit: contain;
      object-position: left center;
    }
  }

  .login-container {
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    width: 40%;
    padding: 7%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;

    .login-form {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;

      ::v-deep .el-input__inner {
        border-radius: 20px;
        background: #ffefed;
        border: 2px solid #ffe6e3;

        &::placeholder {
          color: #666666;
        }
      }

      ::v-deep .el-radio-group {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        width: 100%;
        justify-content: flex-start;
      }

      ::v-deep .el-radio {
        margin-right: 15px;
        margin-bottom: 0;
      }
    }

    .logo {
      width: 360px;
      height: auto;
      margin-bottom: 20px;
    }

    .title {
      margin: 0px auto 10px auto;
      text-align: center;
      color: #FF6B4A;
    }

    .remember {
      margin: 0px 0px 35px 0px;
    }

    .el-radio {
      margin-bottom: 10px;
      margin-top: 10px;
    }
  }
}

.error_text {
  color: red;
  // margin-bottom: 10px;
}

::v-deep  .el-input__suffix{
  right: 0;
}
.send_code{
  border-bottom-right-radius: 20px;
  border-top-right-radius: 20px;
}

.official-link {
  color: #FF6B4A;
  text-decoration: none;
  font-weight: 500;
  font-size: 14px;
  transition: all 0.3s ease;
  padding: 8px 16px;
  border-radius: 15px;
  display: inline-block;

  &:hover {
    color: #e55a41;
    background: rgba(255, 107, 74, 0.1);
    text-decoration: none;
  }
}

.help-links {
  width: 100%;
  text-align: right;
  margin-bottom: 15px;
  margin-top: -5px;
}

.help-link {
  color: #409EFF;
  font-size: 13px;
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    color: #66b1ff;
  }
}

.help-dialog-content {
  word-break: keep-all;
  overflow-wrap: break-word;

  ol {
    padding-left: 20px;
    margin: 15px 0;

    li {
      margin-bottom: 12px;
      line-height: 1.6;
    }
  }

  a {
    color: #409EFF;
    text-decoration: none;
    word-break: keep-all;

    &:hover {
      text-decoration: underline;
    }
  }
}

.forgot-password-content {
  word-break: keep-all;
  overflow-wrap: break-word;

  p {
    margin-bottom: 20px;
    color: #666;
    word-break: keep-all;
    overflow-wrap: break-word;
  }

  ::v-deep .el-form-item {
    margin-bottom: 18px;
  }

  ::v-deep .el-form-item__label {
    padding-bottom: 5px;
    word-break: keep-all;
    overflow-wrap: break-word;
  }
}
</style>
